module.exports = __webpack_public_path__ + "img/YE.c71af6b9.svg";